import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Editor, Toolbar } from 'ngx-editor';
import { GenerateListComponent } from './generate-list/generate-list.component';
import { EmailService } from '../../services/email.service';
import { SendEmailConfirmationComponent } from './confirmation/confirmation.component';

@Component({
  selector: 'app-admin-email-users',
  templateUrl: './email-users.component.html',
  styleUrl: './email-users.component.scss'
})
export class EmailUsersComponent implements OnInit, OnDestroy {
  sending: boolean = false;
  recipientCount: number = 0;
  selectedFile: File | null = null;

  editor!: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  @ViewChild('attachmentInput') attachmentInput: ElementRef | undefined;
  message: { to: string, cc: string, bcc: string, subject: string, body: string } = {
    to: '',
    cc: '',
    bcc: '',
    subject: '',
    body: ''
  };
  modalOpen: boolean = false;
  modalRef: any | null = null;

  constructor(private readonly dialog: MatDialog, private readonly emailService: EmailService) { }

  ngOnInit(): void {
    this.editor = new Editor();
  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }

  send() {
    if (this.recipientCount == 0) { return; }
    this.sending = true;
    this.modalRef = this.dialog.open(SendEmailConfirmationComponent, { data: [ this.message.to, this.message.cc, this.message.bcc].join(';') } );
    this.modalRef.afterClosed().subscribe((result: string | undefined | null) => {
      if (result == 'confirm') { 
        this.emailService.send(this.message, this.selectedFile).subscribe({
          next: (_: any) => {
            this.sending = false;
            this.message = { to: '', cc: '', bcc: '', subject: '', body: '' };
            this.removeAttachment();
            this.recipientCount = 0;
          },
          error: (_: any) => {
            console.error("Error sending email", this.message, _);
            this.sending = false;
          }
        });
      } else { this.sending = false; }
    });
  }
  openGenerateList() {
    this.modalOpen = true;
    this.modalRef = this.dialog.open(GenerateListComponent);
    this.modalRef.afterClosed().subscribe((result: any) => {
      this.modalOpen = false;
      if (result?.type == 'to') { this.message.to += result.emails; }
      if (result?.type == 'cc') { this.message.cc += result.emails; }
      if (result?.type == 'bcc') { this.message.bcc += result.emails; }
      if (result?.type == 'clipboard') { this.copy(result.emails); }
      this.evaluateRecipientCount();
    });
  }

  evaluateRecipientCount() {
    this.recipientCount = ((this.message.to != '') ? (this.message.to.includes(';') ? this.message.to.split(';').filter(Boolean).length : 1) : 0) +
                          ((this.message.cc != '') ? (this.message.cc.includes(';') ? this.message.cc.split(';').filter(Boolean).length : 1) : 0) +
                          ((this.message.bcc != '') ? (this.message.bcc.includes(';') ? this.message.bcc.split(';').filter(Boolean).length : 1) : 0);
  }
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }
  removeAttachment() {
    this.selectedFile = null;
    (this.attachmentInput as ElementRef).nativeElement.value = null;
  }

  private copy(value: any) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
